import decode from 'jwt-decode';
import { IdToken } from '~/contracts/common';
import BrowserCookies from './BrowserCookies';

export { default as safeParse } from './safeParse';
export { BrowserCookies };

export const wait = (ms: number) =>
  new Promise(resolve => setTimeout(resolve, ms));

export function getUserId(
  cookieValue: string | undefined = BrowserCookies.get('CVIdToken')
): string | undefined {
  if (!cookieValue) return undefined;

  try {
    const decodedToken = decode<IdToken>(cookieValue) || {};
    const isExpired = decodedToken.exp * 1000 < Date.now();

    return isExpired ? undefined : decodedToken.user_id;
  } catch (e) {
    return undefined;
  }
}
